import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    // [types.SET_DICTIONARIES]: (state, items) => Vue.set(state, 'items', items),
    [types.SET_DICTIONARIES]: (state, items) =>state.items = items,
    [types.ADD_OR_UPDATE_DICTIONARY_ENTRY]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_DICTIONARY_ENTRY]: (state, item) => removeItem(state, item)
}